<template>
  <div class="boy_warphry">
    <div class="rkcz">
      <div>港澳台和外籍人员</div>
      <div class="two">
        <div class="one">
          <span>{{datas.sw}}</span><span>(人)</span>
          <div>商务</div>
        </div>
        <div class="one">
          <span>{{datas.jy}}</span><span>(人)</span>
          <div>就业</div>
        </div>
        <div class="one">
          <span>{{datas.xx}}</span><span>(人)</span>
          <div>学习</div>
        </div>
        <div class="one">
          <span>{{datas.dj}}</span><span>(人)</span>
          <div>定居</div>
        </div>
        <div class="one">
          <span>{{datas.tq}}</span><span>(人)</span>
          <div>探亲</div>
        </div>
        <div class="one">
          <span>{{datas.qt}}</span><span>(人)</span>
          <div>其他</div>
        </div>
      </div>
    </div>
    <!-- <el-card> -->
    <div class="npm">
      <p>分地区的港澳台和外籍人员居住原因</p>
      <div ref="echartsINof" class="echarts" style="height: 40vh"></div>
    </div>
    <!-- </el-card> -->
  </div>
</template>

<script>
import { tj } from "@/network";
export default {
  data() {
    return {
      datas:{},
      name:"商务"
    };
  },
  created() {},
  mounted() {
    this.getInfoDatas();
    this.getname(); 
    this.getInfoData();
    // this.handEchart();
  },
  methods: {
    getname() {
      let myechart = this.$echarts.init(this.$refs.echartsINof);
      myechart.on("legendselectchanged", (params)=> {
        this.name = params.name;
        this.getInfoData();
      });
    },
    async getInfoDatas() {
      const { code, data, msg } = await tj({
        tableName: "jxq_gathwjry",
        // streetCode: "110105011",
      });
      this.datas=data[0]
      // console.log(data)
    },
    async getInfoData() {
      const { code, data, msg } = await tj({
        tableName: "jxq_gathwjry",
        streetCode: "110105011",
      });
      var compare = function (attribute) {
        return function (obj1, obj2) {
          var val1 = obj1[attribute];
          var val2 = obj2[attribute];
          // if (val1 < val2) {
          //   return 1;
          // } else if (val1 > val2) {
          //   return -1;
          // } else {
          //   return 0;
          // }
        };
      };
      if (this.name == "就业") {
        let datas = data.sort(compare("jy")); //通过Id排序完成后的数组
      } else if(this.name == "学习"){
        let datas = data.sort(compare("xx")); //通过Id排序完成后的数组
      }else if(this.name == "定居"){
        let datas = data.sort(compare("dj")); //通过Id排序完成后的数组
      }else if(this.name == "探亲"){
        let datas = data.sort(compare("tq")); //通过Id排序完成后的数组
      }else if(this.name == "其他"){
        let datas = data.sort(compare("qt")); //通过Id排序完成后的数组
      }else{
        let datas = data.sort(compare("sw")); //通过Id排序完成后的数组
      }
      // console.log(data)
      let czrk = [];
      let villages_name = [];
      let sw = [];
      let jy = [];
      let xx = [];
      let dj = [];
      let tq = [];
      let qt = [];
      for (const item of data) {
        czrk.push(item.czrk);
        villages_name.push(item.villages_name);
        sw.push(item.sw);
        jy.push(item.jy);
        xx.push(item.xx);
        dj.push(item.dj);
        tq.push(item.tq);
        qt.push(item.qt);
      }
      this.handEchart(czrk,villages_name,sw,jy,xx,dj,tq,qt)
    },
    handEchart(e,es,sw,jy,xx,dj,tq,qt) {
      let myechart = this.$echarts.init(this.$refs.echartsINof);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
         legend: {
          selectedMode: "single", //取消图例的点击事件
          textStyle:{
          color:"#fff",
        },
        },
        textStyle:{
          color:"#fff"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: es,
            axisLabel: { interval: 0, rotate: 60 }
          },
          
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "商务",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: sw,
          },
          {
            name: "就业",
            type: "bar",
            stack: "Ad",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: jy,
          },
          {
            name: "学习",
            type: "bar",
            stack: "Ad",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: xx,
          },
          {
            name: "定居",
            type: "bar",
            stack: "Ad",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: dj,
          },
          {
            name: "探亲",
            type: "bar",
            stack: "Search Engine",
            data: tq,
            emphasis: {
              focus: "series",
            },
          },
          {
            name: "其他",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: qt,
          },
        ],
      };
      myechart.setOption(option);
    },
  },
};
</script>

<style scoped lang="less">
.boy_warphry {
  background-color: rgba(20, 48, 99, 0);
  .npm {
    p {
      color: #fff;
      text-align: center;
      font-size: 18px;
      padding: 2vh;
    }
    .echarts{
        margin: 1vw;
    }
  }
}
.rkcz {
  div {
    color: #fff;
    text-align: center;
    margin-top: 2vh;
    font-size: 18px;
    margin-bottom: 2vh;
  }
  .two {
    border: 1px solid #21517d;
    margin: 0 2vw;
    margin-bottom: 0.8vw;
    .one {
      width: 7vw;
      display: inline-block;
      font-size: 18px;
      color: #fffd7d;
      padding-top: 1vh;
      span:nth-child(2) {
        font-size: 12px;
      }
      div {
        font-size: 12px;
        color: #fff;
        margin-top: 5px;
      }
    }
    .aa {
      border-top: 0;
      border-bottom: 0;
      padding: 0 2.5vw;
    }
  }
}
</style>
